import { useTranslation } from '@gem/modules/i18n';
import dateService from '@gem/services/date-service';

import { DEFAULT_DEVICE_PROJECT_NAME } from '../Device.constants';
import { IDevice, IDeviceSession } from '../Device.types';

export interface IDeviceItemProps {
  className?: string;
  projectName?: string;
  device: IDevice;
  deviceSession: IDeviceSession;
  onClick?(): void;
}

interface IDeviceItemPresenterParams extends Omit<IDeviceItemProps, 'className' | 'onClick'> {}

interface IDeviceItemPresenter {
  lastActivity: string;
  deviceOS: string;
  appName: string;
  addFullName: string;
  device: string;
  activity: string;
  sessionInfo: string;
}

export function useDeviceItemPresenter(params: IDeviceItemPresenterParams): IDeviceItemPresenter {
  const { device, deviceSession, projectName = DEFAULT_DEVICE_PROJECT_NAME } = params;

  const { t } = useTranslation();
  const presenter: IDeviceItemPresenter = {
    get lastActivity(): string {
      return (
        dateService.format(deviceSession.lastActivityTs, {
          month: 'long',
          day: 'numeric',
        }) || ''
      );
    },

    get deviceOS(): string {
      const filteredDeviceDetails = [device.osName, device.osVersion].filter(Boolean);
      if (!filteredDeviceDetails.length) {
        return '';
      }
      return filteredDeviceDetails.join(' ');
    },

    get appName(): string {
      return `${projectName} ${device.platform} ${device.appVersion}`;
    },

    get addFullName(): string {
      return [presenter.appName, presenter.deviceOS].filter(Boolean).join(', ');
    },

    get activity(): string {
      return deviceSession.isOnline ? t('common_online') : presenter.lastActivity;
    },

    get device(): string {
      return device.device;
    },

    get sessionInfo(): string {
      return [deviceSession.location, presenter.activity].filter(Boolean).join(' \u2022 ');
    },
  };

  return presenter;
}
